<div class="pdf-viewer-root">
  @if (loading) {
    <div class="pdf-status">
      <p-progress-spinner
        ariaLabel="Loading PDF preview"
        strokeWidth="10"
        styleClass="w-6rem h-6rem"
      />
      <p class="text-sm text-muted-color">Loading PDF preview...</p>
    </div>
  }

  @if (errorMessage) {
    <p-message severity="warn" styleClass="w-full">
      {{ errorMessage }}
    </p-message>
  }

  @if (!loading && !errorMessage && totalPages > 0) {
    <div class="pdf-toolbar">
      <p-button
        icon="pi pi-search-minus"
        ariaLabel="Zoom out"
        [text]="true"
        severity="secondary"
        [disabled]="!canZoomOut"
        (onClick)="zoomOut()"
      />
      <span class="pdf-zoom-label">{{ zoomPercent }}</span>
      <p-button
        icon="pi pi-search-plus"
        ariaLabel="Zoom in"
        [text]="true"
        severity="secondary"
        [disabled]="!canZoomIn"
        (onClick)="zoomIn()"
      />
      <p-button
        icon="pi pi-refresh"
        ariaLabel="Reset to original size"
        [text]="true"
        severity="secondary"
        [disabled]="!canZoomOut"
        pTooltip="Reset to original size"
        tooltipPosition="top"
        (onClick)="resetZoom()"
      />
    </div>
  }

  <div #fitWidth class="pdf-fit-width" aria-hidden="true"></div>
  <div #pagesContainer class="pdf-pages" [class.hidden]="!!errorMessage"></div>
</div>
